<template>
  <div class="o-focus o-tabs__tab--fixed-head">
    <div class="o-panel__header" v-my-fixed-title>
      <h3 class="o-panel__title">Delivering a sustainable business</h3>
    </div>

    <my-slider>
      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body">
          <div class="o-focus__intro">
            <p>Understanding the priorities and perspectives of our customers and other stakeholders helps us build a sustainable business to deliver a service that meets their needs now and in the future. We achieve this understanding through a comprehensive stakeholder engagement programme that includes Critical Friends Panels, forums and focus groups, bespoke events, research and other mechanisms such as newsletters. This year we have broadened and deepened our stakeholder engagement, introducing new layers of engagement such as a CEO Panel to our Critical Friends Panels.</p>
          </div>

          <div class="o-link__btn-group">
            <my-download-button :section="'focus-stakeholder-engagement'"></my-download-button>
            <my-video-button :video-code="'6KxlD7b5juQ'"></my-video-button>
          </div>
        </div>
      </my-slide>

      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body o-panel__body--full o-panel__body--squish">
          <div class="o-grid o-grid--2">

            <div class="o-grid__item o-grid__item--max">
              <div class="o-kpi--circle o-kpi--circle--top o-kpi--circle--red">
                <div class="o-kpi--circle__inner">
                  <h4 class="o-kpi__figure">No.2</h4>
                  <p class="o-kpi__caption">We retained our position as second place in the industry for our stakeholder engagement performance as evaluated by the regulator Ofgem</p>
                </div>
              </div>
            </div>

            <div class="o-grid__item o-grid__item--max">
              <div class="o-kpi--circle o-kpi--circle--top o-kpi--circle--red">
                <div class="o-kpi--circle__inner">
                  <h4 class="o-kpi__figure">44,648</h4>
                  <p class="o-kpi__caption">Number of stakeholders we have engaged with in 2016/17</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </my-slide>

    </my-slider>

  </div>
</template>

<script>
import MyDownloadButton from '@/components/standard/my-download-button'
import MyVideoButton from '@/components/standard/my-video-button'
import { MySlider, MySlide } from '@/components/standard/my-slider'
import { MyFixedTitle } from '@/directives/my-fixed-title.js'

export default {
  name: 'my-focus-stake',
  components: {
    MyDownloadButton,
    MyVideoButton,
    MySlider,
    MySlide
  },
  directives: {
    MyFixedTitle
  }
}
</script>



// WEBPACK FOOTER //
// MyFocusStake.vue?6cfff59f